
import { Fragment, useEffect, useState } from "react";
import "react-phone-number-input/style.css";
import PropTypes from "prop-types";
import { useAppDispatch, useAppSelector } from "../../../app/hooks"
import { useForm, SubmitHandler } from "react-hook-form";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import { authActions, signupLoginStatus, verifyOtpStatus, socialSignupLoginStatus, forgotPasswordStatus } from "../../../reducers/authSlice";
import { useNavigate, NavLink, useSearchParams } from "react-router-dom";
import VerifyPage from './verify';
// import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import { useGoogleLogin } from '@react-oauth/google';
import axios from "axios";
import { decodeJwt } from "../../../utils/common";
import ForgotPasswordModal from "../../../shared/forgot-password-modal/ForgotPasswordModal";
import { useTranslation } from "react-i18next";
import i18n from "../../../i18n";
import { useTranslationContext } from "../../../context/locale.context";
import ReCAPTCHA from 'react-google-recaptcha';

const Register = () => {

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  const target = searchParams.get("target");

  const [showPhoneForm, setShowPhoneForm] = useState(true);
  const [country, setCountry] = useState<any>("CA");
  const signupStatus = useAppSelector(signupLoginStatus);
  const [inputField, setInputField] = useState("");
  const [socialLogin, setSocialLogin] = useState(false);
  const socialSignupStatus = useAppSelector(socialSignupLoginStatus);
  const otpVerificationStatus: string = useAppSelector(verifyOtpStatus);
  const signupVerificationStatus: string = useAppSelector(signupLoginStatus);
  const forgotPassStatus: string = useAppSelector(forgotPasswordStatus);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const { locale, setLocale } = useTranslationContext();
  const [searchParamsValue, setSearchParams] = useSearchParams();

  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const [captchaError, setCaptchaError] = useState(false);

  const handleCaptchaChange = (token: string | null) => {
    setCaptchaToken(token);
    if (token) setCaptchaError(false);
  };

   const handleFormSubmit = () => {
    if (!captchaToken) {
      setCaptchaError(true);
      return;
    }
    onSubmit({ ...getValues(), captchaToken });
  };

  type CredentialInput = {
    phoneOrEmail: any,
    password: string,
    captchaToken:string,
  }

  useEffect(() => {
    // if target is passed then 
    if (target) {
      try {
        decodeJwt(target);
      } catch (err) {
        console.error(err);
        navigate("/LinkExpired");
      }
    }

    dispatch(authActions.reset());
  }, [])

  /**forgot password hook */
  useEffect(() => {
    if (forgotPassStatus === "success") {
      reset();
      setShowForgotPassword(false);
    }
  }, [forgotPassStatus])

  useEffect(() => {
    if (otpVerificationStatus == 'success' || socialSignupStatus == 'success'
      //condtn for username password flow
      || (signupVerificationStatus === 'success' && !showPhoneForm)
    ) {
      navigate("/dashboard")
    }
  }, [otpVerificationStatus, signupVerificationStatus])


  const { register, handleSubmit, formState: { errors }, getValues, trigger, reset } = useForm<CredentialInput>()

  const onSubmit: SubmitHandler<CredentialInput> = data => {

    setInputField(data.phoneOrEmail?.trim());

    let obj: any = {}

    if (showPhoneForm) {
      obj = {
        phone: {
          countryCode: country ? getCountryCallingCode(country) : 1,
          number: data.phoneOrEmail?.trim()
        },
        captchaToken:data?.captchaToken
      }
    } else {
      obj = {
        email: data.phoneOrEmail?.trim(),
        password: data.password?.trim(),
        captchaToken: data?.captchaToken
      }
    }
    obj['role'] = 'merchant';
    dispatch(authActions.signupLogin(obj));
  }

  const changeInputFormType: any = (value: boolean) => {
    reset();
    setCountry("US")
    setShowPhoneForm(value)
  }

  const login = useGoogleLogin({
    onSuccess: async (tokenResponse: any) => {
      try {
        const data = await axios.get("https://www.googleapis.com/oauth2/v3/userinfo", {
          headers: { "Authorization": `Bearer ${tokenResponse.access_token}` }
        })

        setSocialLogin(true)
        if (data) {
          let obj = {
            firstname: data.data.given_name,
            lastname: data.data.family_name,
            email: data.data.email,
            profileImage: data.data.picture,
            googleId: data.data.sub,
            role: 'merchant',
            type: 'socialSignup'
          }
          dispatch(authActions.signupLogin(obj))
        }

      } catch (err) {
        console.log('Error--', err)
      }

    }
  });

  const handleForgotPassword = async ({ phoneOrEmail }: { phoneOrEmail: string }) => {
    /**call forgot password */
    let obj = {
      email: phoneOrEmail,
      role: "merchant"
    }
    dispatch(authActions.forgotPassword(obj));
  }

  const { t } = useTranslation("")

  let search = window.location.search;
  let params = new URLSearchParams(search);
  let localeValue = params.get('locale');

  useEffect(() => {
    if (localeValue) {
      setLocale(localeValue);
      i18n.changeLanguage(localeValue);
      document.cookie = `INTEGOLF_COURSES_PORTAL_LOCALE=${localeValue};`
    }
  }, [localeValue])

  const updateLocale = (locale: string) => {
    if (localeValue) {
      searchParams.set("locale", locale);
      setSearchParams(searchParams);
    }
    setLocale(locale);
    i18n.changeLanguage(locale);
    document.cookie = `INTEGOLF_COURSES_PORTAL_LOCALE=${locale};`
  }

  return (
    <section className="authWrapper">
      <div className="select-language-dropdown">
        <select
          id="languages"
          value={locale ? locale : "en"}
          className="form-select bg-transparent text-dark fw-medium border-1 p-2"
          onChange={(e) => updateLocale(e.target.value)}
        >
          <option value="en">EN</option>
          <option value="fr">FR</option>
        </select>
      </div>
      <div className="authMain flex-fill d-flex align-items-center">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-9">
              {signupStatus != 'success' && <div className="authWrap">
                <div className="text-center mb-4">
                  <h1>
                    {t("AuthPages.WelcomeText")}
                    <span>
                      g<span>o</span>lf
                    </span>
                  </h1>
                  <h6 className="color-gray">{t("AuthPages.LoginOrSignup")}</h6>
                </div>
                <div className="formSection py-5">
                  <div className="formWrap">
                    <form onSubmit={handleSubmit(handleFormSubmit)}>

                      {showPhoneForm && <Fragment>
                        <div className="mb-4">
                          <div className="form-floating" >
                            <CountrySelect
                              labels={en}
                              value={country}
                              onChange={setCountry}
                            />
                            <label htmlFor="region">{t("AuthPages.CountryOrRegion")}</label>
                          </div>
                        </div>
                        <div className="mb-4">
                          <div className="form-floating" >
                            <input
                              type="text"
                              className="form-control"
                              id="phoneNumber"
                              placeholder={t("AuthPages.LoginForm.PhoneNumberPlaceholder")}
                              {...register("phoneOrEmail", {
                                required: true, validate: (value: any) => {
                                  const trimmedValue = value.trim();
                                  const numberPattern = /^[0-9]*$/i;
                                  return numberPattern.test(trimmedValue);
                                }
                              })}
                            />
                            {errors.phoneOrEmail?.type == 'required' && <div className="isInvalidMessage text-danger">{t("AuthPages.LoginForm.requiredError")}</div>}
                            {errors.phoneOrEmail?.type == 'validate' && <div className="isInvalidMessage text-danger">{t("AuthPages.LoginForm.validateError")}</div>}
                            <label htmlFor="phoneNumber">{t("AuthPages.LoginForm.label")}</label>
                          </div>
                        </div>
                      </Fragment>}
                      {!showPhoneForm && <FormTypeEmail setShowForgotPassword={setShowForgotPassword} handleForgotPassword={handleForgotPassword} getValues={getValues} dispatch={dispatch} register={register} errors={errors} trigger={trigger} />}
                      {/* <p>
                        I agree with{" "}
                        <a href="https://www.integolf.com/privacy" target="_blank">Privacy Policy</a>
                         <br /> We'll call
                        or text you to confirm your number.
                      </p> */}

                      {/* 🛡️ ReCAPTCHA */}
                      <div className="mb-3">
                        <ReCAPTCHA
                          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY as string}
                          onChange={handleCaptchaChange}
                        />
                        
                      </div>
                      {captchaError && (
                          <span className="isInvalidMessage text-danger m-1">Please verify you are not a robot</span>
                        )}
                      <div className="mb-4 pt-2">
                        <button
                          type="submit"
                          className="button button-primary button-block button-rounded button-large fw700 fontsize-16"
                        >
                          {t("AuthPages.LoginForm.SignIn")}
                        </button>
                      </div>
                    </form>
                  </div>
                  <div className="formWrapRight">

                    {/* <FacebookLogin
                      appId="666098185251961" // we created this, remember?
                      autoLoad={false}
                      cookie={false}
                      fields="name,email,picture,first_name,last_name"
                      scope="public_profile"
                      render={(renderProps: any) => (
                        <button
                          type="button"
                          className="button button-block button-border button-large button-rounded"
                          onClick={renderProps.onClick}
                        >
                          <span className="icon">
                            <img
                              src="assets/images/icons/facebook.svg"
                              alt="facebook"
                            />
                          </span>{" "}
                          Continue with Facebook
                        </button>
                      )}
                      callback={responseFacebook}
                    /> */}
                    <button
                      type="button"
                      className="button button-block button-border button-large button-rounded"
                      onClick={() => login()}
                    >
                      <span className="icon">
                        <img
                          src="assets/images/icons/google.svg"
                          alt="facebook"
                        />
                      </span>{" "}
                      {t("AuthPages.ContinueWithGoogleText")}
                    </button>
                    {/* <button
                      type="button"
                      className="button button-block button-border button-large button-rounded"
                    >
                      <span className="icon">
                        <img
                          src="assets/images/icons/apple.svg"
                          alt="facebook"
                        />
                      </span>{" "}
                      Continue with Apple
                    </button> */}
                    {showPhoneForm ? (
                      <button
                        type="button"
                        className="button button-block button-border button-large button-rounded"
                        onClick={() => changeInputFormType(false)}
                      >
                        <span className="icon">
                          <img
                            src="assets/images/icons/email.svg"
                            alt="facebook"
                          />
                        </span>{" "}
                        {t("AuthPages.ContinueWithEmailText")}
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="button button-block button-border button-large button-rounded"
                        onClick={() => changeInputFormType(true)}
                      >
                        <span className="icon">
                          <img
                            src="assets/images/icons/phone.svg"
                            alt="facebook"
                          />
                        </span>{" "}
                        {t("AuthPages.ContinueWithPhoneNumberText")}
                      </button>
                    )}
                  </div>
                </div>
              </div>}



              {signupStatus == 'success' && !socialLogin && showPhoneForm && <VerifyPage countryCode={getCountryCallingCode(country)} inputData={inputField} isPhoneInput={showPhoneForm}></VerifyPage>}
            </div>
          </div>
        </div>
      </div>
      {showForgotPassword && <ForgotPasswordModal
        show={showForgotPassword}
        setShow={setShowForgotPassword}
        handleForgotPassword={handleForgotPassword}
      />}
    </section>
  );
};

const FormTypeEmail = ({ setShowForgotPassword, register, errors, trigger, getValues, dispatch, handleForgotPassword }: any) => {


  const { t } = useTranslation("")

  return (
    <Fragment>
      <div className="mb-4 pb-4">
        <div className="form-floating mb-3">
          <input
            type="text"
            className="form-control"
            id="email"
            placeholder={t("AuthPages.LoginForm.EmailForm.formField1.placeholder")}
            {...register("phoneOrEmail", {
              required: true, validate: (value: any) => {
                const trimmedValue = value.trim();
                const emailPattern = /^\S+@\S+$/i;
                return emailPattern.test(trimmedValue);
              }
            })}
          />
          {errors.phoneOrEmail?.type == "required" && <span className="isInvalidMessage text-danger">{t("AuthPages.LoginForm.EmailForm.formField1.requiredError")}</span>}
          {errors.phoneOrEmail?.type == "validate" && <span className="isInvalidMessage text-danger">{t("AuthPages.LoginForm.EmailForm.formField1.validEmailError")}</span>}
          <label htmlFor="email">{t("AuthPages.LoginForm.EmailForm.formField1.label")}</label>
        </div>
        <div className="form-floating">
          <input
            type="password"
            className="form-control"
            id="password"
            placeholder={t("AuthPages.LoginForm.EmailForm.formField2.placeholder")}
            {...register("password", {
              required: true, validate: (value: any) => {
                const trimmedValue = value.trim();
                if (trimmedValue.length < 8) {
                  return false;
                }
                return true;
              }
            })}
          />
          {errors.password?.type == "required" && <span className="isInvalidMessage text-danger">{t("AuthPages.LoginForm.EmailForm.formField2.requiredError")}</span>}
          {errors.password?.type == "validate" && <span className="isInvalidMessage text-danger">{t("AuthPages.LoginForm.EmailForm.formField2.minPasswordError")}</span>}
          <label htmlFor="email">{t("AuthPages.LoginForm.EmailForm.formField2.label")}</label>
          <a
            style={{ color: "#00D19F", float: "right", marginTop: "5px" }}
            onClick={() => setShowForgotPassword(true)}
          >{t("AuthPages.LoginForm.EmailForm.button")}</a>
        </div>

      </div>
    </Fragment>
  )
};

const CountrySelect = ({ value, onChange, labels, ...rest }: {
  value: any;
  onChange: any;
  labels: any;
}) => (
  <select
    className="form-select"
    id="region"
    {...rest}
    defaultValue={"US"}
    value={value}
    onChange={event => onChange(event.target.value || undefined)}
  >
    {getCountries().map((country) => (
      <option key={country} value={country}>
        {labels[country]} +{getCountryCallingCode(country)}
      </option>
    ))}
  </select>
);

CountrySelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  labels: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default Register;
